module.exports = __webpack_public_path__ + "img/auto-user.3caf0ff6.png";